requirejs.config({
    "urlArgs": function (id, url) {
        return (url.indexOf("?") === -1 ? "?" : "&") + "bust=" + document.body.dataset.vegzoneAppbuild;
    },
    waitSeconds : 30,
    "baseUrl": "/Content/js",
    "paths": {
        "jquery": "../libs/jquery/jquery.min",
        "underscore": "../libs/underscore/underscore-min",
        "knockout": "../libs/knockout/build/output/knockout-latest.debug",
        "knockout.mapping": "../libs/knockout-mapping/knockout.mapping.min",
        "knockout.validation": "../libs/knockout.validation/knockout.validation.min",
        "knockout.init": "../libs/knockout-pre-rendered/knockout-pre-rendered.min",
        "popper": "../libs/popper.js/umd/popper.min",
        "bootstrap": "../libs/bootstrap/js/bootstrap.min",
        "plupload": "../libs/plupload/js/plupload.full.min",
        "text": "../libs/requirejs-text/text",
        "async": "../libs/requirejs-async/async",
        "moment": "../libs/moment/min/moment-with-locales.min",
        "select2": "../libs/select2/js/select2.min",
        "chartjs": "../libs/chart.js/Chart.bundle.min",
        "nprogress": "../libs/nprogress/nprogress",
        "wow": "../libs/wowjs/wow.min",
        "typeahead": "../libs/typeahead.js/typeahead.jquery.min",
        "markerclusterer": "utils/markerclusterer",
        "browsergeolocator": "utils/browsergeolocator",
        "isotope": "../libs/isotope-layout/isotope.pkgd.min",
        "jquery.lazyload": "../libs/jquery-lazyload/jquery.lazyload",
        "sammy": "../libs/sammy/lib/min/sammy-latest.min",
        "ckeditor": "../libs/@ckeditor/ckeditor5-build-classic/build/ckeditor",
        "ckeditor-cs": "../libs/@ckeditor/ckeditor5-build-classic/build/translations/cs",
        "ckeditor-sk": "../libs/@ckeditor/ckeditor5-build-classic/build/translations/sk",
        "croppie": "../libs/croppie/croppie.min",
        "exif": "../libs/exif-js/exif",
        "swiper": "../libs/swiper/js/swiper.min",
        "photogallery": "../widgets/photogallery/photogallery",
        "photogallery-template": "../widgets/photogallery/photogallery.html",
        "instagramembed": "https://www.instagram.com/embed",
        "pikaday": "../libs/pikaday/pikaday",
        "datetimepicker": "../libs/tempusdominus-bootstrap-4/build/js/tempusdominus-bootstrap-4.min",
        "requirecss": "../libs/require-css/css.min",
        "hammerjs": "../libs/hammerjs/hammer.min",
        "appleauth": "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth",
        "googleauth": "https://accounts.google.com/gsi/client?noext",
        "pulltorefresh": "../libs/pulltorefresh/index.umd.min",
        "bodyscrolllock": "../libs/body-scroll-lock/bodyScrollLock.min",
        "knockout.sortable": "../libs/knockout.sortable/knockout-sortable",
        "jquery-ui": "../libs/jquery-ui/jquery-ui.min",
        "jquery-ui-touch-punch": "../libs/jquery-ui-touch-punch/jquery.ui.touch-punch.min"
    },
    "shim": {
        "bootstrap": ["jquery", "popper.js"],
        "knockout": ["ko.extracted.bindings"],
        "knockout.mapping": ["knockout"],
        "knockout.validation": ["knockout"],
        "knockout.sortable": ["knockout", "jquery-ui", "jquery-ui-touch-punch"],
        "select2": ["jquery"],
        "bindings/knockout.select2": ["knockout", "select2"],
        "datetimepicker": ["jquery", "utils/globalmoment"],
        "isotope": ["jquery"],
        "imagesloaded": ["jquery"],
        "jquery.lazyload": ["jquery"],
        "typeahead": ["jquery"],
        "croppie": ["jquery", "exif"],
        "plupload": {
            exports: "plupload"
        },
        "googleauth": {
            exports: "google"
        },        
        "ckeditor": {
            exports: "CKEDITOR"
        },
        "ckeditor-cs": ["ckeditor"],
        "ckeditor-sk": ["ckeditor"],
        "wow": {
            exports: "WOW"
        },
        "markerclusterer": {
            exports: "MarkerClusterer"
        },
        "jquery-ui-touch-punch": ["jquery-ui"],
        "jquery-ui/ui/widgets/droppable": {
            deps: ["jquery-ui", "jquery-ui-touch-punch"],
            exports: "$.ui.droppable"
        },
        "jquery-ui/ui/widgets/draggable": {
            deps: ["jquery-ui", "jquery-ui-touch-punch"],
            exports: "$.ui.draggable"
        },
        "jquery-ui/ui/widgets/sortable": {
            deps: ["jquery-ui", "jquery-ui-touch-punch"],
            exports: "$.ui.sortable"
        }
    },
    nodeIdCompat: true,
    map: {
        '*': {
            'css': 'requirecss',
            "jquery-ui/ui/widgets/droppable": "jquery-ui",
            "jquery-ui/ui/widgets/draggable": "jquery-ui",
            "jquery-ui/ui/widgets/sortable": "jquery-ui"
        }
    } 
});

requirejs(["app/application"]);

define("setup", function(){});

